// extracted by mini-css-extract-plugin
export var active = "_lf-2";
export var recordingDot = "_lf-1";
export var recordingIndicator = "_lf-0";